import React, { Component, Fragment, useEffect } from "react";
import ReactDOM from "react-dom";
import Masonry from 'react-masonry-css';
import axios from 'axios'
import InfiniteScroll from 'react-infinite-scroll-component';
import ReactRouterPropTypes from 'react-router-prop-types';
import Autosuggest from 'react-autosuggest';
import ReactHelmet from "../Header/ReactHelmet";

import { Link } from "react-router-dom";

import MainPixelogCard from "./MainPixelogCard";
import "./pixelog-main.css";

import PixelogHeader from "../Header/PixelogHeader";

import AdSense from 'react-adsense-ad';

function ScrollToTopOnMount() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return null;
}

//메인 리스트 출력
class MainPixelogSearchList extends Component {

  constructor(props) {
    super();

    this.state = {
      offset:0,
      limit:50,
      ItemList: [],
      hasMore: true,
      remain:50,
    };
  }

  //처음 1회
  loadData = async (next) => {
    const { history, match } = this.props;    
    let hasmore;

    if(next !== undefined){
      var type = next.split('=')[0];
      var query = encodeURIComponent(next.split('=')[1]);
    }else{
      var type = match.params.query.split('=')[0];
      var query = encodeURIComponent(match.params.query.split('=')[1]);
    }

    axios
      .get(`/search/${type}/${query}/0/50`)
      .then( ({data}) => {

        if(data.piskelsCount < 50){
          hasmore = false;
        }else{
          hasmore = true;
        }

        this.setState({
          ItemList: [...data.piskels],
          offset: 0,
          limit: 50,
          remain: data.piskelsCount,
          hasMore: hasmore,
          type:type,
          query:query,
        }, () => {
          history.replace(undefined, { ...this.state });
      });
      })
      .catch( e => {
        console.error(e);
      });
  };  

  moreloadData = async () => {
    const { offset, limit, type, query } = this.state;
    const { history, location } = this.props;    
    let hasmore;

    axios
      .get(`/search/${type}/${query}/${offset+limit}/${limit}`)
      .then( ({data}) => {

        if(data.piskelsCount < 50){
          hasmore = false;
        }else{
          hasmore = true;
        }

        this.setState({
          ItemList: [...this.state.ItemList,...data.piskels],
          offset: this.state.offset + this.state.limit,
          limit: this.state.limit,
          remain: data.piskelsCount,
          hasMore: hasmore,
          type:type,
          query:query,
        }, () => {
          history.replace(undefined, { ...this.state });
      });
      })
      .catch( e => {
        console.error(e);
      });
  };  


  componentDidMount() {
    
    const { history, location } = this.props;

    window.onbeforeunload = (e) => {
      history.replace(undefined, undefined);
    };

    if(!location.state){
      this.loadData();
    }else{
      this.setState({ ...location.state });
    }

  }//componentDidMount


  shouldComponentUpdate(nextProps, nextState){

  if(this.props.match.params.query !== nextProps.match.params.query){

    this.loadData(nextProps.match.params.query);
    return false;

  }else{

    if(this.state.ItemList == nextState.ItemList){
      return false;

    }else{
      return true;
    }    
  }

  }//shouldComponentUpdate

  handleLikeChange = async (v) => {

    const { history } = this.props;
    const targetItemId = v.id; // 업데이트하려는 항목의 id

    if (Array.isArray(this.state.ItemList)) {
      const updatedItemList = this.state.ItemList.map(item => {
        if (item.id === targetItemId) {
          return {...item, likes: v.likes}; // likes 값을 1 증가
        }
        return item; // 변경하지 않을 항목은 그대로 반환
      });

      this.setState({ItemList: updatedItemList}, () => {
        history.replace(undefined, { ...this.state });
      });
    }
  }

  render() {

    const { ItemList, query, type } = this.state;
    const { history, location } = this.props;

    var winUid = window.__pageInfo.uid;

    const list = ItemList.map(
      (itemdata, id) => (
        <MainPixelogCard
          key={itemdata.id}
          id={itemdata.id}
          dataKey={itemdata.key}
          uid={itemdata.uid}
          fps={itemdata.fps}
          frames={itemdata.frames}
          nick={itemdata.nick}
          winUid={winUid}
          likes={itemdata.likes}
          created_at={itemdata.created_at}
          type={itemdata.type}
          onLikeChange={this.handleLikeChange}
          name={itemdata.name}
        />
      )
    );

    var searchType = '';
    if(type == 'tag'){
      searchType = '태그';
    }else if(type == 'title'){
      searchType = '제목';
    }else if(type == 'query'){
      searchType = '통합';
    }

    const breakpointColumnsObj = {
      default: 2,
      5039: 19,
      4787: 18,
      4535: 17,
      4283: 16,
      4031: 15,
      3779: 14,
      3527: 13,
      3275: 12,
      3023: 11,
      2771: 10,
      2519: 9,
      2267: 8,
      2015: 7,
      1763: 6,
      1511: 5,
      1199: 4,
      899: 3,
      699: 2, //699 까지 2개
    };

    return (
      <Fragment>

        <ScrollToTopOnMount />

        <PixelogHeader 
          history={this.props.history}   
        />

        <ReactHelmet
          title={`${query} - ${searchType} 검색`}
        />

          {
            list.length == 0 ? 
            (
              <div id="grid" className="grid mt-5">
                <div className="w-100 alert alert-white text-center " role="alert">
                  <h5>'{query}' 에 대한 검색결과가 없습니다.</h5>
                </div>
              </div>
            ) 
            :
            (

              <Fragment>
                {/* 모바일 - 검색 리스트 상단 광고 (그림일기, 픽셀아트 공통) */}
                  <div className='d-block d-sm-none ad-view-conatainer'>
                    <div className='ad-view'>
                      <AdSense.Google
                        className=''
                        client='ca-pub-9216699597615631'
                        slot='6355888115'
                        style={{ display:'flex', height:'100px', width:'320px' }}
                        format=''
                      />
                    </div>
                  </div>


            <InfiniteScroll
              dataLength={this.state.ItemList.length} //This is important field to render the next data
              next={this.moreloadData}
              style={{ overflow:'visible' }}
              // scrollThreshold="100%"
              hasMore={this.state.hasMore}
              loader={
                  <div className="spin-container pb-3">
                    <div className="spinner-border" style={{"width":"3rem", "height":"3rem"}} role="status"></div>
                  </div>
              }
              // endMessage={
              //   <p style={{ textAlign: 'center' }}>
              //     <b>마지막 페이지 입니다.</b>
              //   </p>
              // }      
            >

              <div className="row m-0 justify-content-sm-center mt-3">
                <div className="col-12 col-sm-auto m-0 p-0">
                  <Masonry
                    breakpointCols={breakpointColumnsObj}
                    className="my-masonry-grid grid row gx-2"
                    columnClassName=""
                  >                      
                    {list}         
                  </Masonry>
                </div>

                <div className="col-12 col-sm-3 col-xl-4 m-0 col-ad-list pe-0 ps-ad">

                  {/* 모바일 - 검색 리스트 하단 광고 모바일 (그림일기, 픽셀아트 공통) */}
                  <div className='d-block d-sm-none ad-view-conatainer' style={{"marginTop":"4rem"}}>
                    <div className='ad-view'>
                      <AdSense.Google
                        className=''
                        client='ca-pub-9216699597615631'
                        slot='6355888115'
                        style={{ display:'flex', height:'100px', width:'320px' }}
                        format=''
                      />
                    </div>
                  </div>                   

                  {/*-------------- ------------ sm -------------- ------------*/}
                  {/* PC - 검색 리스트 광고1 125 X 125 (그림일기, 픽셀아트 공통) */}
                  <div className="card ad-list-container-small d-none d-sm-block d-xl-none">
                    <div className="card-body p-0">
                      <h5 className="ad-card-title text-start">광고</h5>
                      <div className="ad-list ad-list-1">
                        <AdSense.Google
                          className=''
                          client='ca-pub-9216699597615631'
                          slot='3762642691'
                          style={{ display:'flex', width:'125px', height:'125px' }}
                          format=''
                        />
                      </div>
                    </div>
                  </div>

                  {/* PC - 검색 리스트 광고2 PC 120 X 600 (그림일기, 픽셀아트 공통) */}
                  <div className="card ad-list-container d-none d-sm-block d-md-none">          
                    <div className="card-body p-0">
                      <h5 className="ad-card-title text-start">광고</h5>
                      <div className="ad-list ad-list-2">
                      <AdSense.Google
                        className=''
                        client='ca-pub-9216699597615631'
                        slot='4158104807'
                        style={{ display:'flex', width:'120px', height:'600px' }}
                        format=''
                      />
                      </div>
                    </div>
                  </div>

                  {/*-------------- ------------ md -------------- ------------*/}
                  {/* PC - 검색 리스트 광고2 PC 160 X 600 (그림일기, 픽셀아트 공통) */}
                  <div className="card ad-list-container d-none d-md-block d-xl-none">          
                    <div className="card-body p-0">
                      <h5 className="ad-card-title text-start">광고</h5>
                      <div className="ad-list ad-list-2">
                      <AdSense.Google
                        className=''
                        client='ca-pub-9216699597615631'
                        slot='8001756675'
                        style={{ display:'flex', width:'160px', height:'600px' }}
                        format=''
                      />
                      </div>
                    </div>
                  </div>

                  {/*-------------- ------------ xl -------------- ------------*/}
                  {/* PC - 검색 리스트 광고2 PC 300 X 600 (그림일기, 픽셀아트 공통) */}
                  <div className="card ad-list-container d-none d-xl-block">          
                    <div className="card-body p-0">
                      <h5 className="ad-card-title text-start">광고</h5>
                      <div className="ad-list ad-list-2">
                      <AdSense.Google
                        className=''
                        client='ca-pub-9216699597615631'
                        slot='2353844173'
                        style={{ display:'flex', width:'300px', height:'600px' }}
                        format=''
                      />
                      </div>
                    </div>
                  </div>  
                </div>
              </div> 
            </InfiniteScroll>
            </Fragment>
            )
          }

      </Fragment>
    );
  }
}

MainPixelogSearchList.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  location: ReactRouterPropTypes.location.isRequired,
};

export default MainPixelogSearchList;
